export class LearningMapper {
  static mapToLearningPathDetail (response) {
    const learningDetail = {
      id: response.id,
      title: response.title,
      excerpt: response.excerpt,
      content: response.content,
      featureImage: response.feature_image,
      totalHours: response.total_hours,
      totalVideos: response.total_videos,
      totalArticles: response.total_articles,
      totalQuizzes: response.total_quizzes,
      totalLessons: response.total_no_of_lessons,
      lessonTopic: response.lesson_topic,
      assignment: [],
    }
    if (response.assignment?.length > 0) {
      response.assignment.forEach(data => {
        const obj = {
          title: data.title,
          lesson: this.mapToLessons(data.lesson),
        }
        learningDetail.assignment.push(obj)
      })
    }
    return learningDetail;
  }
  static mapToLessons (response) {
    const lessons = []
    let setActive = false
    if (response?.length > 0) {
      response.forEach(lesson => {
        const obj = {
          id: lesson.id,
          name: lesson.name,
          slug: lesson.slug,
          taxonomy: lesson.taxonomy,
          termTaxonomyId: lesson.term_taxonomy_id,
          chapterCount: lesson.chaper_count,
          description: lesson.description,
          totalArticles: lesson.total_no_of_articles,
          totalVideos: lesson.total_no_of_videos,
          totalLengthVideos: lesson.total_length_of_videos,
          coinsEarned: lesson.coins_earned,
          difficultyLevel: lesson.difficulty_level,
          isPopular: lesson.is_popular,
          icon: lesson.icon,
          completed: lesson.completed,
          active: false
        }
        if (!setActive) {
          if (!lesson.completed) {
            obj.active = true
            setActive = true
          }
        }
        lessons.push(obj)
      })
    }
    return lessons;
  }
}
